const mFeedSectionContentCardEditionDesign3 = {
  mFeedSectionContentCardEditionDesign3: {
    infoPrice: {
      buy: 'COMPRAR',
      free: 'GRATIS',
      noprice: 'SIN PRECIO'
    },

    messages: {
      nameLength: '* Longitud permitida de nombre: de 5 a 120 caracteres'
    },

    validation: {
      nombre: {
        maxLength: 'La longitud máxima permitida de nombre es de 120 caracteres.',
        minLength: 'La longitud mínima permitida de nombre es de 5 caracteres.',
        required: 'Nombre de producto es requerido. De 5 a 120 caracteres.'
      }
    }
  }
}

export default mFeedSectionContentCardEditionDesign3
